const VisualStatic = require('visual-static');

class Form extends VisualStatic {
  init() {
    this.orderOfFormFields = ['name', 'business_name', 'sole_proprietor', 'c_corporation', 's_corporation', 'partnership', 'trust_estate', 'llc', 'tax', 'other', 'other_details', 'payee', 'fatca', 'address', 'city', 'state', 'zip', 'account_numbers', 'requester_name', 'requester_address', 'r_city', 'r_state', 'r_zip', 'ss1', 'ss2', 'ss3', 'ein1', 'ein2', 'sign_date'];

    this.initOnReactComponentsMounted();
  }

  initBuilderOnReactComponentsMounted() {
    this.initBuilder();

    // Set the correct order of fields
    VisualStatic.setTabOrder(this.orderOfFormFields);

    // For older browsers use our POLYFILL to add the appropriate placeholders
    $('input').placeholder();

    VisualStatic.initExportPDF();
  }
}

module.exports = Form;



// WEBPACK FOOTER //
// ./src-assets/js/form-w9-2014.js